export const AGENCIA = {admin: true, loja: true};
export const COMUNICACAO = {admin: true, loja: true};
export const TRADE = {admin: true, loja: true};



// WEBPACK FOOTER //
// ./src/config/turnOnOff.js